import { useContext } from "react";
import type { TabWindow } from "~/pages/dashboard/task/task.types";
import { TabWindowsActionsContext, TabWindowsStateContext } from "../context/tab-windows-context";

export const useTabWindowsState = <T = unknown>() => {
  const context = useContext(TabWindowsStateContext);

  if (context === undefined) {
    throw new Error("useTabWindowsState must be used within a TabWindowsProvider");
  }

  return context as typeof context & { windows: TabWindow<T>[] };
};

export const useTabWindowsActions = <_T = unknown>() => {
  const context = useContext(TabWindowsActionsContext);

  if (context === undefined) {
    throw new Error("useTabWindowsActions must be used within a TabWindowsProvider");
  }

  return context as typeof context;
};

export const useTabWindowsContext = <T = unknown>() => {
  const state = useTabWindowsState<T>();
  const actions = useTabWindowsActions<T>();

  return { ...state, ...actions };
};
